import { render, staticRenderFns } from "./_currencyField.vue?vue&type=template&id=5183841c"
import script from "./_currencyField.vue?vue&type=script&lang=js"
export * from "./_currencyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports